<template>
  <div class="login-page">
    
    <!-- Login Section -->
    <section class="login-section">
      <div class="login-background">
        <img :src="Images.login.background" alt="Login Background" class="login-bg-image">
      </div>
      <div class="login-container">
        <!-- Login Form -->
        <div class="login-form" v-if="activeForm === 'login'">
          <h2 class="login-title">账号登录</h2>
          <div class="form-group">
            <input type="number" class="form-input" v-model="loginForm.phone" placeholder="手机号" required>
          </div>
          <div class="form-group">
            <input type="password" class="form-input" v-model="loginForm.password" placeholder="密码" required>
          </div>
          <button class="login-button" @click="login">登录</button>
          <div class="login-links">
            <a href="#" class="login-link" @click.prevent="switchToRegister">注册用户</a>
            
            <router-link to="/forgot-password" class="login-link">忘记密码</router-link>
          </div>
          <div class="divider">
            <span class="divider-text">------------------ 其他登录方式 ------------------</span>
          </div>
          <div class="other-login-methods">
            <button class="wechat-login" @click="redirectToWechatLogin">
              <img :src="Images.login.wechat" alt="WeChat" class="wechat-icon">
            </button>
          </div>
        </div>
        <!-- Register Form -->
        <div class="login-form register-form" v-else>
          <h2 class="login-title">用户注册</h2>
          <div class="form-group">
            <input type="number" class="form-input" v-model="formData.phone" placeholder="手机号" required>
          </div>
          <div class="form-group">
            <div class="verification-code">
              <input type="number" class="form-input code-input" v-model="formData.verificationCode" placeholder="验证码" required>
              <button class="send-code-button" @click="sendVerificationCode" :disabled="countdown > 0">
                {{ countdown > 0 ? `${countdown}秒后重发` : '发送验证码' }}
              </button>
            </div>
          </div>
          <div class="form-group">
            <input type="password" class="form-input" v-model="formData.password" placeholder="密码" required>
          </div>
          <div class="form-group">
            <input type="password" class="form-input" v-model="formData.confirmPassword" placeholder="确认密码" required>
          </div>
          <button class="login-button" @click="register">立即注册</button>
          <div class="login-links">
            <a href="#" class="login-link" @click.prevent="switchToLogin">已有账号，去登录</a>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import { Images } from '@/utils/imageLoader';
import { userApi } from '@/utils/api';
import store from '@/utils/store';

export default {
  name: 'LoginView',
  data() {
    return {
      activeForm: 'login', // 'login' 或 'register'
      Images,
      // 表单数据
      formData: {
        phone: '',
        verificationCode: '',
        password: '',
        confirmPassword: ''
      },
      // 登录表单数据
      loginForm: {
        phone: '',
        password: ''
      },
      // 验证码相关
      countdown: 0, // 倒计时秒数
      countdownTimer: null // 倒计时定时器
    }
  },
  mounted() {
    // 检查URL是否包含注册锚点
    this.checkHash()
    // 检查是否是微信登录回调
    this.checkWechatLoginCallback()
  },
  watch: {
    // 监听URL变化
    $route() {
      this.checkHash()
    },
    // 监听窗口hash变化
    '$route.hash'() {
      this.checkHash()
    }
  },
  methods: {
    checkHash() {
      // 检查URL是否包含注册锚点
      if (window.location.hash === '#register' || this.$route.hash === '#register') {
        this.activeForm = 'register'
      } else {
        this.activeForm = 'login'
      }
    },
    // 检查微信登录回调
    checkWechatLoginCallback() {
      // 获取完整的URL
      const url = window.location.href;
      console.log('当前URL:', url);
      
      // 使用正则表达式提取参数，处理非标准格式的URL（使用&而非?）
      const phoneMatch = url.match(/phone=([^&]+)/);
      const avatarMatch = url.match(/(?:avatar|vatar)=([^&]+)/);
      
      const phone = phoneMatch ? decodeURIComponent(phoneMatch[1]) : null;
      const avatar = avatarMatch ? decodeURIComponent(avatarMatch[1]) : null;
      
      console.log('提取的参数 - phone:', phone, 'avatar:', avatar);
      
      if (phone) {
        // 微信登录成功，获取到用户信息
        console.log('微信登录成功，获取到用户昵称:', phone);
        console.log('微信登录成功，获取到用户头像:', avatar);
        
        // 将用户信息存储到store中
        const userInfo = {
          nickname: phone, // 这里phone实际上是用户昵称
          avatar: avatar || '',
          phone: '' // 可能需要从其他地方获取phone
        };
        
        // 直接调用setUser mutation设置用户信息
        store.mutations.setUser(userInfo);
        alert('微信登录成功');
        
        // 跳转到首页并清除URL参数
        this.$router.push('/home');
      }
    },
    switchToLogin() {
      this.activeForm = 'login'
      // 更新URL锚点
      window.history.replaceState(null, null, '#login')
    },
    switchToRegister() {
      this.activeForm = 'register'
      // 更新URL锚点
      window.history.replaceState(null, null, '#register')
    },
    // 发送验证码
    sendVerificationCode() {
      // 验证手机号
      if (!this.formData.phone) {
        alert('请输入手机号');
        return;
      }
      
      if (this.formData.phone.toString().length !== 11) {
        alert('请输入正确的手机号');
        return;
      }
      
      // 调用API发送验证码
      userApi.sendVerificationCode(this.formData.phone, 4)
        .then(data => {
          console.log('验证码发送成功:', data);
          alert('验证码发送成功');
          // 开始倒计时
          this.startCountdown();
        })
        .catch(error => {
          console.error('验证码发送失败:', error);
          alert('验证码发送失败: ' + (error.msg || '请稍后重试'));
        });
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    // 用户注册
    register() {
      // 表单验证
      if (!this.formData.phone) {
        alert('请输入手机号');
        return;
      }
      
      if (this.formData.phone.toString().length !== 11) {
        alert('请输入正确的手机号');
        return;
      }
      
      if (!this.formData.verificationCode) {
        alert('请输入验证码');
        return;
      }
      
      if (!this.formData.password) {
        alert('请输入密码');
        return;
      }
      
      if (this.formData.password.length < 6) {
        alert('密码长度至少6位');
        return;
      }
      
      if (this.formData.password !== this.formData.confirmPassword) {
        alert('两次输入的密码不一致');
        return;
      }
      
      // 准备注册数据，将verificationCode映射为code
      const registerData = {
        phone: this.formData.phone,
        code: this.formData.verificationCode,
        password: this.formData.password
      };
      
      // 调用API注册
      userApi.register(registerData)
        .then(data => {
          console.log('注册成功:', data);
          alert('注册成功，即将跳转到登录页面');
          // 跳转到登录页面
          this.switchToLogin();
          // 清空表单
          this.formData = {
            phone: '',
            verificationCode: '',
            password: '',
            confirmPassword: ''
          };
        })
        .catch(error => {
          console.error('注册失败:', error);
          alert('注册失败: ' + (error.msg || '请稍后重试'));
        });
    },
    // 用户登录
    login() {
      // 表单验证
      if (!this.loginForm.phone) {
        alert('请输入手机号');
        return;
      }
      
      if (this.loginForm.phone.toString().length !== 11) {
        alert('请输入正确的手机号');
        return;
      }
      
      if (!this.loginForm.password) {
        alert('请输入密码');
        return;
      }
      
      // 调用API登录
      userApi.login(this.loginForm)
        .then(data => {
          console.log('登录成功:', data);
          // 登录成功后，将电话号码存储到store中
          const userInfo = {
            phone: data // 这里的data就是返回的电话号码
          };
          // 直接调用setUser mutation设置用户信息
          store.mutations.setUser(userInfo);
          alert('登录成功');
          // 跳转到首页
          this.$router.push('/home');
        })
        .catch(error => {
          console.error('登录失败:', error);
          alert('登录失败: ' + (error.msg || '请稍后重试'));
        });
    },
    
    // 跳转到微信登录链接
    redirectToWechatLogin() {
      // 直接跳转到微信登录URL
      window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx2e775985fa9ed767&redirect_uri=https://api.xibaihui.cn/sysOfficialWebsiteUser/wechat/callback&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect';
    }
  },
  created() {
    // 组件创建时的逻辑
  },
  beforeUnmount() {
    // 清理定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.login-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 0 80px;
  position: relative;
  flex: 1;
}

.login-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
}

.login-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-container {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.login-form {
  background-color: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.login-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

.form-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;
}

.verification-code {
  display: flex;
  gap: 10px;
  align-items: center;
}

.code-input {
  flex: 1;
}

.send-code-button {
  padding: 12px 20px;
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.send-code-button:hover {
  background-color: #ff8533;
}

.form-input:focus {
  border-color: #ff6b00;
}

.login-button {
  width: 100%;
  padding: 12px;
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-bottom: 20px;
}

.login-button:hover {
  background-color: #ff8533;
}

.login-links {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

/* 注册表单中的登录链接居中 */
.register-form .login-links {
  justify-content: center;
}

.login-link {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.login-link:hover {
  color: #ff6b00;
}

/* 移除数字输入框的上下箭头 */
/* Chrome, Safari, Edge, Opera */
.login-form input[type=number]::-webkit-inner-spin-button,
.login-form input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.login-form input[type=number] {
  -moz-appearance: textfield;
}

.divider {
  text-align: center;
  margin-bottom: 30px;
}

.divider-text {
  color: #999;
  font-size: 14px;
}

.other-login-methods {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.wechat-login {
  width: 40px;
  height: 40px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: transform 0.3s;
}

.wechat-login:hover {
  transform: scale(1.1);
}

.wechat-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* WeChat Login QR Code Styles */

</style>